import { IGetGeneralPetCareResponse, ISocByPetForReminderCard } from "./standard-of-care.interface";
import { PET_CARE, SOC_DATA_BY_PETS } from "./standard-of-care.query";

import { useApolloClient, useLazyQuery } from "@apollo/client";
import { useState } from "react";

// cache.evict() + useLazyQuery(cache-and-network)
// doesn't work due to Apollo #7171: useLazyQuery
// skips network even after eviction.
// Using client.query(network-only) as workaround.
export const usePetGeneralCare = () =>{
  const client = useApolloClient();
  const [petCare, setPetCare] = useState<IGetGeneralPetCareResponse | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const getGeneralCare = async (id: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const { data } = await client.query<{
        getGeneralCareByPetV2: IGetGeneralPetCareResponse;
      }>({
        query: PET_CARE,
        variables: { id },
        fetchPolicy: "network-only",
      });
      setPetCare(data?.getGeneralCareByPetV2);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    petCare,
    isLoading,
    error,
    getGeneralCare,
  };
};

export const useSocDatByPetReminderCard = () => {
  const [getSocDataByPets, { data, loading, error }] =
    useLazyQuery<{ socByPetId: ISocByPetForReminderCard }>(SOC_DATA_BY_PETS);


  const getSocDataByPetsForReminderCard = (id: string[]) => {
    getSocDataByPets({
      variables: {
        ids: id,
      },
    });
  };

  return {
    socDataByPet: data?.socByPetId.pets,
    isLoading: loading,
    error,
    getSocDataByPetsForReminderCard,
  };
};
